import React, { useCallback, useEffect, useState } from "react"
import styled from "styled-components"
import { useForm } from "react-hook-form"
import Modal from "@motorata/base-ui.components.molecules.modal"
import { Box } from "@motorata/base-ui.components.atoms._atoms"
import Button from "@motorata/base-ui.components.atoms.button"
import Input from "@motorata/base-ui.components.atoms.input"
import { EMAIL_REGEX, PHONE_STRING_REGEX } from "@motorata/base-ui.utils.regex"
import Link from "next/link"
import Checkbox from "@motorata/base-ui.components.atoms.checkbox"
import { removeSpacesFromPhoneNumber } from "@motorata/base-ui.utils.string"
import { LeadService } from "@motorata/base-ui.services.api-service"
import { CalculateParamsType, CalculateType } from "@motorata/base-ui.types.api";
import { translate } from "@motorata/base-ui.data";
import { SentryService } from "@motorata/base-ui.services.sentry-service";
import { AnalyticsService } from "@motorata/base-ui.services.segment-service";
import { TagManagerService } from "@motorata/base-ui.services.tag-manager-service";
import GiftModalContent from "../shared/GiftModalContent";

const CalculatorModal = ({ type, state, calculation, show, setShow }: {
  type: "leasing" | "credit"
  state: CalculateParamsType
  calculation: CalculateType
  show: boolean
  setShow: any
}) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm()

  const checkbox = watch("checkbox")

  const [loading, setLoading] = useState(false)

  const onSubmit = useCallback(
    async (el: any) => {
      try {
        setLoading(true)
        await LeadService.add("calculator", {
          firstName: el.firstName,
          lastName: "",
          email: el.email,
          phone: removeSpacesFromPhoneNumber(el.phone),
          message: `${translate(state.type)} ${state.price} PLN ${state.priceType} / ${state.period} msc. / ${state.payment}% / ${state.repurchase}% / ${calculation?.price} zł/m-c`,
        })
        TagManagerService.truck("lead_calculator")
        AnalyticsService.track("Finance Calculator Send", {
          page: type,
          ...state
        })
        setShow("success")
      } catch (e) {
        SentryService.error("[ERROR LeadService.add[mr_calculator] API]", e)
      } finally {
        setLoading(false)
      }
    },
    [state],
  )

  useEffect(() => {
    if(show){
      AnalyticsService.track("Finance Calculator Open", {
        page: type,
      })
    }
    if (!show) {
      reset()
    }
  }, [show])

  return (
    <Modal title="Otrzymaj bezpłatną ofertę" show={show} setShow={setShow} maxWidth="500px">
      <GiftModalContent />
      <Content onSubmit={handleSubmit(onSubmit)}>
        <Input
          name="firstName"
          label="Imię*"
          error={errors.firstName}
          value={watch("firstName")}
          marginBottom="XS"
          rhf={register("firstName", {
            required: true,
          })}
        />
        <Input
          name="email"
          label="E-mail*"
          error={errors.email}
          value={watch("email")}
          marginBottom="XS"
          rhf={register("email", {
            required: true,
            pattern: {
              value: EMAIL_REGEX,
              message: "Niepoprawny format email",
            },
          })}
        />
        <Input
          name="phone"
          label="Telefon*"
          error={errors.phone}
          elementType="pattern"
          format="+48 ### ### ###"
          formattedValue={true}
          value={watch("phone")}
          marginBottom="S"
          rhf={register("phone", {
            required: true,
            pattern: {
              value: PHONE_STRING_REGEX,
              message: "Niepoprawny format telefonu. +48 123 456 789",
            },
          })}
        />
        {/*<StyledGrid>*/}
        {/*  <Input*/}
        {/*    name="firstName"*/}
        {/*    label="Imię*"*/}
        {/*    error={errors.firstName}*/}
        {/*    value={watch("firstName")}*/}
        {/*    rhf={register("firstName", {*/}
        {/*      required: true,*/}
        {/*    })}*/}
        {/*  />*/}
        {/*  <Input*/}
        {/*    name="lastName"*/}
        {/*    label="Nazwisko*"*/}
        {/*    error={errors.lastName}*/}
        {/*    value={watch("lastName")}*/}
        {/*    rhf={register("lastName", {*/}
        {/*      required: true,*/}
        {/*    })}*/}
        {/*  />*/}
        {/*  <Input*/}
        {/*    name="phone"*/}
        {/*    label="Telefon*"*/}
        {/*    error={errors.phone}*/}
        {/*    elementType="pattern"*/}
        {/*    format="+48 ### ### ###"*/}
        {/*    formattedValue={true}*/}
        {/*    value={watch("phone")}*/}
        {/*    rhf={register("phone", {*/}
        {/*      required: true,*/}
        {/*      pattern: {*/}
        {/*        value: PHONE_STRING_REGEX,*/}
        {/*        message: "Niepoprawny format telefonu. +48 123 456 789",*/}
        {/*      },*/}
        {/*    })}*/}
        {/*  />*/}
        {/*  <Input*/}
        {/*    name="email"*/}
        {/*    label="E-mail"*/}
        {/*    error={errors.email}*/}
        {/*    value={watch("email")}*/}
        {/*    rhf={register("email", {*/}
        {/*      required: false,*/}
        {/*      pattern: {*/}
        {/*        value: EMAIL_REGEX,*/}
        {/*        message: "Niepoprawny format email",*/}
        {/*      },*/}
        {/*    })}*/}
        {/*  />*/}
        {/*</StyledGrid>*/}
        {/*<Input*/}
        {/*  name="message"*/}
        {/*  label="Dodatkowa wiadomość"*/}
        {/*  error={errors.message}*/}
        {/*  multiline={true}*/}
        {/*  rows={4}*/}
        {/*  maxRows={4}*/}
        {/*  value={watch("message")}*/}
        {/*  rhf={register("message")}*/}
        {/*  marginBottom="S"*/}
        {/*/>*/}
        <Box mb="20px">
          <Checkbox
            name="checkbox"
            value={checkbox}
            error={errors.checkbox}
            rhf={register("checkbox", {
              required: true,
            })}
          >
            *Oświadczam, że zapoznałem/-am się z <Link href="/regulamin">Regulaminem</Link> i{" "}
            <Link href="/polityka-prywatnosci">Polityką prywatności</Link> oraz akceptuję ich
            postanowienia.
          </Checkbox>
        </Box>
        <Button loading={loading} submit width="100%">
          Wyślij
        </Button>
      </Content>
    </Modal>
  )
}

export default CalculatorModal

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${({ theme }) => theme.space.S};
  margin-bottom: ${({ theme }) => theme.space.S};

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

const Content = styled.form``
